export default theme => ({
  root: {},
  hubBasket: {
    border: `2px solid ${theme.palette.border}`,
    borderRadius: '5px',
  }
});

